import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { 
  FiGrid, 
  FiFileText, 
  FiBook, 
  FiImage, 
  FiUsers, 
  FiBriefcase, 
  FiStar, 
  FiLogOut,
  FiX,
  FiUserPlus,
  FiInbox,
  FiUserCheck,
  FiLayout,
  FiFolder,
  FiSettings,
  FiUpload,
  FiSliders
} from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import './Sidebar.css';

const menuGroups = [
  {
    items: [
      { path: '/dashboard', icon: FiGrid, label: 'Dashboard' },
    ],
  },
  {
    label: 'Records',
    items: [
      { path: '/news', icon: FiFileText, label: 'News' },
      { path: '/blogs', icon: FiBook, label: 'Blogs' },
      { path: '/gallery', icon: FiImage, label: 'Gallery' },
      { path: '/clients', icon: FiUsers, label: 'Clients' },
      { path: '/services', icon: FiBriefcase, label: 'Services' },
      { path: '/reviews', icon: FiStar, label: 'Reviews' },
      { path: '/careers', icon: FiUserPlus, label: 'Careers' },
      { path: '/careers/applications', icon: FiInbox, label: 'Applications' },
      { path: '/team', icon: FiUserCheck, label: 'Our Team' },
    ],
  },
  {
    label: 'Website Content',
    items: [
      { path: '/cms/pages', icon: FiLayout, label: 'Pages' },
      { path: '/cms/media', icon: FiFolder, label: 'Media Library' },
      { path: '/cms/settings', icon: FiSettings, label: 'Site Settings' },
    ],
  },
  {
    label: 'Billing',
    items: [
      { path: '/billing/invoices', icon: FiFileText, label: 'Invoices' },
      {
        path: '/billing/clients',
        icon: FiUsers,
        label: 'Billing Clients',
        // Prefix matching would also light this up on /billing/clients/import
        isActive: (pathname) => pathname.startsWith('/billing/clients') && !pathname.startsWith('/billing/clients/import'),
      },
      { path: '/billing/clients/import', icon: FiUpload, label: 'Import Clients' },
      { path: '/billing/settings', icon: FiSliders, label: 'Billing Settings' },
    ],
  },
];

const Sidebar = ({ isOpen, onClose }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      <div 
        className={`sidebar-overlay ${isOpen ? 'active' : ''}`} 
        onClick={onClose}
      />
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <img src="/logo.png" alt="Design & Infra" className="logo-icon" />
            <div className="logo-text">
              <span className="logo-title">Design & Infra</span>
              <span className="logo-subtitle">Engineering</span>
            </div>
          </div>
          <button className="sidebar-close" onClick={onClose}>
            <FiX />
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuGroups.map((group, index) => (
            <div className="nav-group" key={group.label || `group-${index}`}>
              {group.label && <span className="nav-group-label">{group.label}</span>}
              <ul className="nav-list">
                {group.items.map((item) => (
                  <li key={item.path}>
                    <NavLink 
                      to={item.path} 
                      className={({ isActive }) => `nav-link ${(item.isActive ? item.isActive(pathname) : isActive) ? 'active' : ''}`}
                      onClick={onClose}
                    >
                      <item.icon className="nav-icon" />
                      <span className="nav-label">{item.label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <FiLogOut className="nav-icon" />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
